function getPronounDisplay(pronouns = []) {
    if (pronouns.length === 1) {
        return pronouns[0]
    }

    return pronouns.map((pronoun) => pronoun.split('/')[0]).join('/');
}

export { getPronounDisplay }